import { takeEvery, call, put } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import callAdapter from '@/utils/sagaHelper';
import actions from '../constants';
import DatasetReportsService from '../service';
import {
  dictionaryReportDownloadError,
  dictionaryReportDownloadSuccess,
  fetchDictionaryReportsError,
  fetchDictionaryReportsSuccess,
} from '../actions';

export function* dictionaryReports(action) {
  const {
    category,
    code,
    reportType,
  } = action;
  const { response, error } = yield call(callAdapter, DatasetReportsService.dictionaryReports(code, reportType));
  if (error) {
    yield put(fetchDictionaryReportsError(category, code, reportType, error));
  } else {
    yield put(fetchDictionaryReportsSuccess(category, code, reportType, response));
  }
}

export function* dictionaryReportDownload(action) {
  const {
    code,
    downloadFile,
    reportType,
    report,
  } = action;
  const { response, error } = yield call(
    callAdapter,
    DatasetReportsService.dictionaryReportDownload(code, reportType, report.id),
  );
  if (error) {
    yield put(dictionaryReportDownloadError(
      'downloads',
      code,
      reportType,
      report,
      error,
      downloadFile,
    ));
  } else {
    yield put(dictionaryReportDownloadSuccess('downloads', code, reportType, report, response));
    if (downloadFile) {
      saveAs(new Blob([response]), report.name);
    }
  }
}

export default function* datasetReportsApi() {
  yield takeEvery(actions.FETCH_DICTIONARY_REPORTS, dictionaryReports);
  yield takeEvery(actions.DICTIONARY_REPORT_DOWNLOAD, dictionaryReportDownload);
}
